import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'input-radio',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.css']
})
export class InputRadioComponent {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() name: string = '';
  @Input() value: number | string = 1;
  @Input() defaultValue: number | string | null = 0;
  @Input() label: string = '';


  constructor() { }


  onUncheckRadio() {
    if (+this.control.value === this.value) {
      this.control.setValue(this.defaultValue);
    }
  }

}
